export const dataQueryPrefix = "Share summary statistics for humidity and temperature for tag ";
export const dataQuerySuffix = " Share number of datapoints used to calculate this.";
export const timeRangeMapper = {
    "1w": " for the last week.",
    "1m": " for the last month.",
    "6m": " for the last 6 months.",
    "1y": " for the last year."
}
//Time range options:
export const timeRangeOptions = [
    {label: '1w', value: '1w'},
    {label: '1m', value: '1m'},
    {label: '6m', value: '6m'},
    {label: '1y', value: '1y'}
]
export const mqttTimeRangeOptions = [
    {label: '8h', value: '8h'},
    {label: '1d', value: '1d'},
    {label: '1w', value: '1w'},
    {label: '2w', value: '2w'},
    {label: '4w', value: '4w'}
]
export const actionTimeRangeOptions = [
    {label: 'Immediate', value:'2s'},
    {label: '16 seconds', value:'16s'},
    {label: '1 hour', value:'1h'},
    {label: '8 hours', value:'8h'},
    {label: '1 day', value: '1d'},
    {label: '2 days', value: '2d'},
    {label: '3 days', value: '3d'},
    {label: '4 days', value: '4d'},
    {label: '1 week', value: '1w'}
]

export const sensorTypeLabels = {
    "temperature": {
        "label": "Temperature",
        "unit": "°F",
        "min": 0,
        "max": 100,
        "color": "lightsalmon"
    },
    "humidity": {
        "label": "Humidity",
        "unit": "%",
        "min": 0,
        "max": 100,
        "color": "lightgreen"
    },
    "distance": {
        "label": "Water Level",
        "unit": "\"\"",
        "min": 0,
        "max": 5.0,
        "color": "lightblue"
    },
    "distancetwo": {
        "label": "Water Level 2",
        "unit": "\"\"",
        "min": 0,
        "max": 5.0,
        "color": "#4DD0E1"
    },
    "distance2": {
        "label": "Water Level 2",
        "unit": "\"\"",
        "min": 0,
        "max": 5.0,
        "color": "#4DD0E1"
    },
    "moisture": {
        "label": "Moisture",
        "unit": "%",
        "min": 0,
        "max": 100,
        "color": "lightblue"
    },
    "irrigation": {
        "label": "Irrigation",
        "unit": "on/off",
        "min": 0,
        "max": 1.2,
        "color": "lightgray"
    },
    "irrigation2": {
        "label": "Irrigation 2",
        "unit": "on/off",
        "min": 0,
        "max": 1.2,
        "color": "#90CAF9"
    },
    "lux": {
        "label": "Light",
        "unit": "on/off",
        "min": 0,
        "max": 1,
        "color": "yellow"
    },
    "light": {
        "label": "Light",
        "unit": "on/off",
        "min": 0,
        "max": 1,
        "color": "lightgray"
    },
    "camera": {
        "label": "Camera",
        "unit": "on/off",
        "min": 0,
        "max": 1,
        "color": "#E8E8E8"
    }
}

export const ACTION_CONFIGS = {
    irrigation: {
        settings: [
            {
                label: "Trigger",
                type: "select",
                options: actionTimeRangeOptions,
                key: "tracking"
            },
            {
                label: "Duration (s)",
                type: "number",
                min: 1,
                max: 32,
                key: "duration"
            },
            {
                label: "Use Sensor Data",
                type: "checkbox",
                key: "sensorTracking",
                description: "When enabled, device uses water level sensor data to make watering decisions. When disabled, device follows only the time-based schedule."
            }
        ]
    },
    irrigation2: {
        settings: [
            {
                label: "Trigger",
                type: "select",
                options: actionTimeRangeOptions,
                key: "tracking"
            },
            {
                label: "Duration (s)",
                type: "number",
                min: 1,
                max: 32,
                key: "duration"
            },
            {
                label: "Use Sensor Data",
                type: "checkbox",
                key: "sensorTracking",
                description: "When enabled, device uses water level 2 sensor data to make watering decisions. When disabled, device follows only the time-based schedule."
            }
        ]
    },
    light: {
        settings: [
            {
                label: "Start Time",
                type: "time",
                key: "startTime"
            },
            {
                label: "End Time",
                type: "time",
                key: "endTime"
            },
            {
                label: "Timezone",
                type: "select",
                options: [
                    { value: "UTC", label: "UTC" },
                    { value: "America/Chicago", label: "Central Time" },
                    { value: "America/New_York", label: "Eastern Time" }
                ],
                key: "timezone"
            }
        ]
    },
    fan: {
        settings: [
            {
                label: "Trigger",
                type: "select",
                options: actionTimeRangeOptions,
                key: "tracking"
            }
        ]
    },
    camera: {
        settings: [
            {
                label: "Trigger",
                type: "select",
                options: actionTimeRangeOptions,
                key: "tracking"
            },
            {
                label: "Recording Duration (minutes)",
                type: "number",
                min: 1,
                max: 60,
                key: "recordingDuration"
            },
            {
                label: "Image Quality",
                type: "select",
                options: [
                    { value: "low", label: "Low (640x480)" },
                    { value: "medium", label: "Medium (1280x720)" },
                    { value: "high", label: "High (1920x1080)" }
                ],
                key: "imageQuality"
            }
        ]
    }
};